
import { defineComponent } from 'vue';

export default defineComponent({
	name: 'number-input',

	props: {
		autofocus: {
			type: Boolean,
			default: false
		}
	},

	emits: ['input-value'],

	data() {
		return {
			number: ''
		};
	},

	methods: {
		inputValue() {
			if (!this.number) return;
			this.$emit('input-value', this.number);
			this.number = '';
		}
	}
});
